/**
 * WhatsApp Payments: the values and rules the API validates an `order_details`
 * / `order_status` message against, and the dashboard builds one with.
 */
export const PAYMENT_CURRENCIES = ['INR', 'BRL', 'SGD'] as const;
export const PAYMENT_TYPES = ['upi', 'br', 'p2m-lite:stripe'] as const;
export const PAYMENT_GATEWAYS = [
  'razorpay',
  'payu',
  'zaakpay',
  'billdesk',
] as const;
export const PIX_KEY_TYPES = ['CPF', 'CNPJ', 'EMAIL', 'PHONE', 'EVP'] as const;
export const ORDER_STATUSES = [
  'pending',
  'processing',
  'partially_shipped',
  'shipped',
  'completed',
  'canceled',
] as const;
export const PAYMENT_STATUSES = ['pending', 'captured', 'failed'] as const;

/** Meta's character limits that both the API and the dashboard's inputs enforce. */
export const PAYMENT_LIMITS = {
  configurationName: 60,
  itemName: 60,
  orderStatusDescription: 120,
} as const;

/** `value / offset` is the amount; `offset` is 100 for every supported currency. */
export interface PaymentAmount {
  value: number;
  offset: number;
}

/** Works as a regex source and as an input's `pattern` attribute. */
export const ORDER_REFERENCE_ID_PATTERN = '[A-Za-z0-9_.\\-]+';

export const maxOrderReferenceIdLength = (currency?: string) =>
  currency === 'BRL' ? 60 : 35;

/** Meta rejects an order whose `total_amount` is not this. */
export const orderTotalValue = (order: {
  subtotal: PaymentAmount;
  tax: PaymentAmount;
  shipping?: PaymentAmount;
  discount?: PaymentAmount;
}) =>
  order.subtotal.value +
  order.tax.value +
  (order.shipping?.value ?? 0) -
  (order.discount?.value ?? 0);

/** How the contact pays: payment settings, or a payment type with its configuration. */
export const namesPayment = (parameters: {
  payment_settings?: unknown[];
  payment_type?: string;
  payment_configuration?: string;
}) =>
  !!(
    parameters.payment_settings?.length ||
    (parameters.payment_type && parameters.payment_configuration)
  );
